<template>
  <div class="alp">
      <div class="desc" style="text-align: justify">
          提示：因手机系统的版本不一致，较旧的版本内容可能会有一些出入，请尽量升级到最新版本
      </div>
      <div class="tips">
          <div class="title">
              <div class="icon">1</div>
              <span class="font" style="#000">打开App Store，滑到【APP】页面底部</span>
          </div>
          <img src="./img/1.png" style="width: 78px"/>
      </div>

      <div class="tips">
          <div class="title">
              <div class="icon">2</div>
              <span class="font" style="#000">选择【绑定支付宝、微信支付宝或银联卡】</span>
          </div>
          <img src="./img/2.png" style="width: 244px"/>
      </div>

      <div class="tips">
          <div class="title">
              <div class="icon">3</div>
              <span class="font" style="#000">勾选“银联/信用卡/借记卡”，输入号码、有效期、安全码等个人有效信息，点击【完成】，根据苹果的操作提示完成后则绑定成功</span>
          </div>
          <img src="./img/step3_card@3x.png" style="width: 244px"/>
      </div>

      <div class="tips">
          <div class="title">
              <div class="icon">4</div>
              <span class="font" style="#000">开通完成后可以看到【管理付款方式】页面增加了银联支付方式</span>
          </div>
          <img src="./img/4.png" style="width: 244px"/>
      </div>

      <div class="tips">
          <div class="title">
              <div class="icon">5</div>
              <span class="font" style="#000">开通完成后自动跳转到此页，可以看到【管理付款方式】页面增加了支付宝支付</span>
          </div>
          <img src="./img/5.png" style="width: 244px"/>
      </div>

      <img class="w-full" src="./img/p1-QQ.jpg"/>
  </div>
</template>

<script>
export default {
  name: 'yinsi',
  mounted () {
    document.title = '绑定银联'
  }
}
</script>

<style>
    .w-full {
        width: 100%;
    }
</style>

<style lang="scss" scoped>
    .alp {
        color: #000;
        background: #F7F7F7;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        >.desc {
            padding: px2html(10px) px2html(15px);
            box-sizing: border-box;
            width: px2html(345px);
            background: rgba(115, 174, 242, 0.12);
            color: #73AEF2;
            margin-bottom: px2html(20px);
            margin-top: px2html(10px);
        }
        >.tips {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: px2html(30px);
            .title {
                display: flex;
                align-items: flex-start;
                text-align: justify;
                margin-bottom: px2html(20px);
                width: px2html(332px);
                transform: translateX(px2html(-5px));
                .icon {
                    margin-right: px2html(5px);
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    font-size: px2html(16px);
                    line-height: px2html(2px);
                    color: #fff;
                    min-width: px2html(23px);
                    min-height: px2html(23px);
                    background: url("../../assets/t-icon.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
                .font {
                    transform: translateY(px2html(3px));
                    font-size: px2html(16px);
                    line-height: px2html(28px);
                }
            }
        }
    }
</style>
